/**
 * Enumerate the languages to be consumed by the PIT API
 *
 * @export
 * @enum {number}
 */
export enum PITLanguage {
  CS = "cs_CZ", // Tschechisch
  DA = "da_DK", // Dänisch
  DE = "de_DE", // Deutsch
  EN = "en_GB", // Englisch (Großbritannien)
  ES = "es_ES", // Spanisch (Traditionelle Sortierung)
  FR = "fr_FR", // Französisch
  IT = "it_IT", // Italienisch
  NL = "nl_NL", // Niederländisch
  PL = "pl_PL", // Polnisch
  PT = "pt_PT", // Portugiesisch
}
/**
 * Enumerate the Regions/Markets/Countries to be consumed by the PIT API
 *
 * @export
 * @enum {number}
 */
export enum PITRegions {
  AT = "at", // Österreich
  AU = "au", // Australien
  BE = "be", // Belgien
  CH = "ch", // Schweiz
  CZ = "cz", // Tschechien
  DE = "de", // Deutschland
  DK = "dk", // Dänemark
  GB = "uk", // Großbritannien
  ES = "es", // Spanien
  FR = "fr", // Frankreich
  GLOBAL = "os", // International
  IT = "it", // Italien
  PL = "pl", // Polnisch
}
